// Sessões abertas.
//
// É a tela que responde "alguém entrou na minha conta?" — e a que permite
// fechar a porta sem trocar a senha e reconfigurar tudo.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import * as conta from "../api/conta";
import { explicar } from "../api/problema";
import { dataCurta } from "../ui/formato";
import { Secao } from "./DoisFatores";

/** O user-agent cru não diz nada a quem não é técnico. */
function aparelho(ua: string | undefined): string {
  const t = ua ?? "";
  const navegador = /Firefox/.test(t)
    ? "Firefox"
    : /Edg\//.test(t)
      ? "Edge"
      : /Chrome/.test(t)
        ? "Chrome"
        : /Safari/.test(t)
          ? "Safari"
          : "";
  const sistema = /iPhone|iPad/.test(t)
    ? "iPhone/iPad"
    : /Android/.test(t)
      ? "Android"
      : /Mac OS X|Macintosh/.test(t)
        ? "Mac"
        : /Windows/.test(t)
          ? "Windows"
          : /Linux/.test(t)
            ? "Linux"
            : "";
  if (!navegador && !sistema) return t ? "Outro programa" : "Desconhecido";
  return [navegador, sistema].filter(Boolean).join(" · ");
}

export function Sessoes() {
  const fila = useQueryClient();
  const lista = useQuery({ queryKey: ["conta", "sessoes"], queryFn: () => conta.sessoesAbertas() });
  const encerrar = useMutation({
    mutationFn: (uuid: string) => conta.encerrarSessao(uuid),
    onSuccess: () => void fila.invalidateQueries({ queryKey: ["conta", "sessoes"] }),
  });

  return (
    <Secao titulo="Sessões abertas" icone="ScrollText">
      <p className="text-sm text-tinta-media">
        Onde sua conta está conectada agora. Não reconhece alguma? Encerre e
        troque a senha.
      </p>

      {lista.isError && <p className="mt-3 text-sm text-perigo">{explicar(lista.error)}</p>}

      <ul className="mt-4 divide-y divide-linha rounded-lg border border-linha">
        {lista.data?.map((s) => (
          <li key={s.uuid} className="flex items-center gap-3 px-4 py-3 text-sm">
            <span className="flex-1 min-w-0">
              <span className="block truncate text-tinta">
                {aparelho(s.user_agent)}
                {s.atual && (
                  <span className="ml-2 rounded-full bg-acao-clara px-2 py-0.5 text-xs text-acao-escura">
                    esta sessão
                  </span>
                )}
              </span>
              <span className="block text-xs text-tinta-fraca">
                {s.ip} · último uso {dataCurta(s.ultimo_uso)}
              </span>
            </span>
            {/* A sessão atual não tem botão: encerrá-la daqui seria um jeito
                confuso de sair, e o menu da conta já faz isso com clareza. */}
            {!s.atual && (
              <button
                onClick={() => encerrar.mutate(s.uuid!)}
                className="text-xs text-perigo underline"
              >
                Encerrar
              </button>
            )}
          </li>
        ))}
      </ul>
    </Secao>
  );
}
